import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, <React.StrictMode><BrowserRouter><App /></BrowserRouter></React.StrictMode>);
} else {
  createRoot(rootElement).render(<React.StrictMode><BrowserRouter><App /></BrowserRouter></React.StrictMode>);
}
